/**
 * @fileoverview Drag State - ドラッグ状態の共有管理
 * InteractAdapter と DragSystem 間での状態共有に用いるモジュール
 */

const sharedDragState = {
  axis: null, // 'x' | 'y' | null
  isDragging: false,
  startX: 0,
  startY: 0,
  currentX: 0,
  currentY: 0,
  swapExecuted: false,
};

/**
 * 現在のドラッグ状態をコピーして返す
 * @returns {Object}
 */
export function getDragState() {
  return { ...sharedDragState };
}

/**
 * ドラッグ開始時の初期化
 * @param {number} startX
 * @param {number} startY
 */
export function beginDragSession(startX, startY) {
  sharedDragState.isDragging = true;
  sharedDragState.startX = startX;
  sharedDragState.startY = startY;
  sharedDragState.currentX = 0;
  sharedDragState.currentY = 0;
  sharedDragState.axis = null;
  sharedDragState.swapExecuted = false;
}

/**
 * 軸情報を更新
 * @param {'x'|'y'|null} axis
 */
export function setDragAxis(axis) {
  sharedDragState.axis = axis;
}

/**
 * 現在の移動量を記録
 * @param {number} x
 * @param {number} y
 */
export function setDragOffset(x, y) {
  sharedDragState.currentX = x;
  sharedDragState.currentY = y;
}

/**
 * スワップ済みフラグを立てる
 */
export function markSwapExecuted() {
  sharedDragState.swapExecuted = true;
}

/**
 * 任意プロパティの更新
 * 既存テスト互換のため残置
 * @param {Object} updates
 */
export function updateDragState(updates) {
  Object.assign(sharedDragState, updates);
}

/**
 * ドラッグ状態のリセット
 */
export function resetDragState() {
  sharedDragState.axis = null;
  sharedDragState.isDragging = false;
  sharedDragState.startX = 0;
  sharedDragState.startY = 0;
  sharedDragState.currentX = 0;
  sharedDragState.currentY = 0;
  sharedDragState.swapExecuted = false;
}
